import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import CreditExposureDetailViewModel from "viewModels/timeCharges/distributors/creditExposures/creditExposureDetailViewModel";
import EditableDetailView from "../../../common/editableDetailView";
import CreditExposureForm from "./creditExposureForm";
import { Modal } from "react-bootstrap";

const CreditExposureDetailView: ViewComponent<CreditExposureDetailViewModel> = observer(({ vm }) => {
  return (
    <Modal scrollable show={true} onHide={vm.requestClose} centered>
      <Modal.Body>
        <EditableDetailView vm={vm} titleClassName="text-left" form={<CreditExposureForm vm={vm} />} />
      </Modal.Body>
    </Modal>
  );
});

registerView(CreditExposureDetailView, CreditExposureDetailViewModel);
